import { Component, OnInit, ViewChild, TemplateRef, Input, EventEmitter, Output } from '@angular/core';
import { EpGridComponent, IEpGridModel, EpEventService, IEpGridSelectionOptions, IEpGridState, IEPGridDataResult, EpButtonStyle, IEpComponentEventArg,
    IEpGridSelectableSettings } from '@epicor/kinetic';
import { CustomEvents, PageNames } from 'ep-bt-controls';
import { Observable } from 'rxjs';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaProductGridModel } from '../../models/epbt-fa-product-grid-model';
import { ActivatedRoute, Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductBinlocationService } from '../../services/epbt-fa-product-binlocation.service';
declare var $: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'epbt-fa-product-grid',
    templateUrl: './epbt-fa-product-grid.component.html',
    styleUrls: ['./epbt-fa-product-grid.component.scss']
})
export class EpbtFaProductGridComponent implements OnInit {

    // Templates
    @ViewChild('currencyTemplate', { static: true }) currencyTemplate: TemplateRef<any>;
    @ViewChild('decimalTemplate', { static: true }) decimalTemplate: TemplateRef<any>;

    // Emitters
    @Output() loadingChange = new EventEmitter<boolean>();

    // Styles
    EpButtonStyle = EpButtonStyle;

    // Properties for Grid
    products: any;
    public gridModel: IEpGridModel;
    public pageSize: number;
    private _searchString: string;
    @Input('searchString') set searchString(value: string) {
        this._searchString = value;
    }
    get searchString(): string { return this._searchString; }
    productsCollection: any = [];
    totalPages = 1;
    showGrid = true;
    pageArray: Array<number> = [];
    lastPage: number;
    lastRecords: any;
    mobileData: any;
    isLastRecords = false;
    isMoreEnable = false;

    // Events
    @Output() epOnCellClick = new EventEmitter<any>();

    // Input Properties
    @Input() model: EpbtFaProductGridModel;

    // @Input() bistrackSettings: any;
    fromPage: string = PageNames.ProductSearch;
    // @Input() webTrackUser: any;
    // @Input() loadDataOnload: boolean = false;

    // Properties for API
    currency: string;
    branchId: number;
    bisTrackUserHasReadAccessToTheseBranches: any = [];
    customerId: number;
    selectedProduct: any;
    pageNames = PageNames;
    webTrackUser: any;
    bisTrackSettings: any;

    constructor(public epEvent: EpEventService,
        private productService: EpbtFaProductService,
        private sortService: EpbtFaSortService, private router: Router,
        public faService: EpbtFieldAgentService, private binLocationService: EpbtFaProductBinlocationService, ) {
        this.epEvent.onEvents([CustomEvents.ProductSearch]).subscribe(event => {
            this._searchString = event.data ? event.data : '';
            this.sortService.productSearchValue = this._searchString;
            this.productService.productSearch(this._searchString, (selectedProduct: any) => {
                if (selectedProduct) {
                    this.epOnCellClick.emit(selectedProduct);
                } else {
                    if (this.productService.fromPage !== this.pageNames.ProductSearch) {
                        if (event.data == '' && sortService.isFromSorting) {
                            this.productService.isProductsSearchMessage = true;
                            this.updateProductsGridData();
                        } else if (event.data == undefined || event.data == '') {
                            this.productService.isProductsSearchMessage = true;
                            this.updateProductsGridData();
                        } else {
                            this.productService.isProductsSearchMessage = false;
                            this.updateProductsGridData();
                        }
                    } else {
                        this.updateProductsGridData();
                    }
                }
            });

        });
    }

    ngOnInit() {
        this.fromPage = this.model.fromPage;

        if (this.fromPage != PageNames.BinLocationProductSearch)
            this.branchId = this.model.branchId;
        else
            this.branchId = this.binLocationService.selectedBranchId;

        if (this.model.bistrackSettings) {
            this.currency = this.model.bistrackSettings.baseCurrency.symbol;
            this.pageSize = this.model.bistrackSettings.searchPageSize;
        }

        if (this.model.webTrackUser) {
            this.bisTrackUserHasReadAccessToTheseBranches = this.model.webTrackUser.bisTrackUserHasReadAccessToTheseBranches;
            this.customerId = this.model.webTrackUser.customer.customerId;
        }

        if (this.model.loadDataOnload) {
            this.gridModel = this.getGridModel([]);
        }
    }

    getGridModel(productList: any): IEpGridModel {
        const selectSettings: IEpGridSelectableSettings = {
            checkboxOnly: false,
            mode: 'single',
        };
        const selectionOptions: IEpGridSelectionOptions = {
            selectByField: 'productCode',
            selectedKeys: [],
        };
        const model: IEpGridModel = {
            resizable: false,
            reorderable: false,
            groupable: false,
            filterable: false,
            pageable: true,
            pageSize: this.pageSize,
            scrollable: 'scrollable',
            rowHeight: 20,
            height: this.getHeight(),
            sortable: false,
            selectionOptions: selectionOptions,
            selectable: selectSettings,
            data: productList,
            columns: [
                { field: 'productCode', title: 'CODE', width: 30, hidden: false },
                { field: 'description', title: 'DESCRIPTION', width: 30, hidden: false },
                { field: 'standardSellPrice', title: 'SELL PRICE', width: 30, hidden: false, cellTemplate: this.currencyTemplate },
                { field: 'stockAvailable', title: 'AVAIL', width: 30, hidden: false, cellTemplate: this.decimalTemplate },
                { field: 'binLocations', title: 'BIN(S)', width: 30, hidden: this.fromPage == PageNames.BinLocationProductSearch ? false : true }
            ],
            epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
                if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
                    this.epOnCellClick.emit(eventArg.event.dataItem);
                }
            },
            loader: (epGrid: EpGridComponent, state: IEpGridState) => {
                const observerResult = this.getProductsGridModelData(epGrid, state, productList, false);
                return observerResult;
            }
        };
        $(window).resize(() => {
            this.updateGrid();
        });
        return model;
    }

    updateGrid() {
        const calHeight = this.getHeight();
        this.gridModel.height = calHeight;
    }

    getProductsGridModelData(epGrid: EpGridComponent, state: IEpGridState, productList, isMobile: boolean): Observable<IEPGridDataResult> {
        const observerResult = new Observable<IEPGridDataResult>(observer => {
            if (!isMobile) {
                epGrid.model.loadingIndicator = true;
            }
            const index = state.skip + state.take;
            let length: number = this.productsCollection.length ? this.productsCollection.length : 0;
            const pageNumber = Math.ceil(index / state.take);
            const pageIndex = this.pageArray.indexOf(pageNumber);
            if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
                epGrid.model.loadingIndicator = false;

                const showoff = pageNumber == this.lastPage ? this.lastRecords : this.productsCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
                const result: IEPGridDataResult = {
                    data: showoff,
                    total: this.totalPages
                };
                observer.next(result);
                observer.complete();
            } else {
                this.customerId = this.model.webTrackUser.customer.customerId;
                this.bisTrackUserHasReadAccessToTheseBranches = this.model.webTrackUser.bisTrackUserHasReadAccessToTheseBranches;
                this.productService.getProductListGridData(
                    this._searchString, this.branchId, this.bisTrackUserHasReadAccessToTheseBranches, this.model.bistrackSettings.searchMOLTsInProductFindInOrderEntry,
                    this.customerId, this.pageSize, state.skip, (res: any) => {
                        productList = res.lines;
                        if (productList != null && productList != undefined && productList.length > 0) {
                            this.totalPages = res.resultCount;
                            this.lastPage = Math.ceil(this.totalPages / state.take);
                            if (pageNumber != this.lastPage) {
                                this.pageArray.push(pageNumber);
                            }
                            if (!isMobile) {
                                epGrid.model.loadingIndicator = false;
                            }
                            if (productList.length < state.take) {
                                this.lastRecords = productList;
                            } else {
                                this.productsCollection = [...this.productsCollection, ...productList];
                            }
                            if (!isMobile) {
                                this.mobileData = this.productsCollection;
                                if (this.lastRecords && this.lastRecords.length > 0) {
                                    this.mobileData = [...this.mobileData, ...this.lastRecords];
                                }
                                this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
                            }
                            length = this.productsCollection.length;
                            const result: IEPGridDataResult = {
                                data: productList,
                                total: this.totalPages
                            };
                            observer.next(result);
                            observer.complete();
                        } else {
                            const result: IEPGridDataResult = {
                                data: [],
                                total: 0
                            };
                            observer.next(result);
                            observer.complete();
                            if (!isMobile) {
                                epGrid.model.loadingIndicator = false;
                            }
                            this.isMoreEnable = false;
                            this.mobileData = this.mobileData ? this.mobileData : [];
                        }
                    });
            }
            this.loadingChange.emit(false);
        });
        return observerResult;
    }

    // grid height calculation start
    getHeight(): number {
        const height = $(window).outerHeight() - 170;
        const width = parseInt($('body').width());

        if (width > 250 && width < 1023) {
            // mobile and ipad
            return 400;
        }

        return height;
    }

    updateProductsGridData() {
        this.lastPage = 0;
        this.lastRecords = undefined;
        this.mobileData = undefined;
        this.isLastRecords = false;
        this.pageArray.length = 0;
        this.isMoreEnable = false;
        this.gridModel = undefined;
        this.productsCollection.length = 0;
        this.showGrid = false;
        setTimeout(() => {
            this.showGrid = true;
            this.loadingChange.emit(true);
            this.gridModel = this.getGridModel([]);
        }, 200);
    }

    getProductsMobileData() {
        const take = this.pageSize;
        for (let i = 1; i <= this.lastPage; i++) {
            const index = this.pageArray.indexOf(i);
            if (index == -1) {
                const state: IEpGridState = {
                    skip: (i - 1) * take,
                    take: take
                };
                let epGrid: EpGridComponent;
                this.getProductsGridModelData(epGrid, state, [], true).subscribe(res => {
                    if (res.data && res.data.length > 0) {
                        let j = 0;
                        if (res.data.length == state.take) {
                            res.data.forEach(element => {
                                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                                j++;
                            });
                        }
                        if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
                            this.mobileData = [...this.mobileData, ...this.lastRecords];
                            this.isLastRecords = true;
                        }
                        this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
                    }
                });
                break;
            }
        }
    }

    onCardClick(model) {
        this.epOnCellClick.emit(model);
    }
}
